import { useMutation } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupAzureModel } from '../types';

import { buildUrl } from './backupSettings.service';

export function useExportAzureBackupMutation() {
  return useMutation(exportAzureBackup, {
    ...withError('Unable to back up to Azure Blob Storage'),
  });
}

async function exportAzureBackup(payload: BackupAzureModel) {
  try {
    const { data } = await axios.post(buildUrl('azure', 'execute'), payload);

    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to back up to Azure Blob Storage'
    );
  }
}
